
<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Add news</strong>
          </div>
          <b-form>
            <b-form-group
              validated
              label="Title" label-for="newsTitle"
              :label-cols="3"
              :horizontal="true">
              <b-form-input id="newsTitle" 
                        type="text" required
                        autocomplete="name" 
                        v-model="newsData.title" 
                        size="lg" 
                        placeholder="Enter news title...">
              </b-form-input>
            </b-form-group>
            <b-form-group
              validated
              label="Subtitle" label-for="newsSubtitle"
              :label-cols="3"
              :horizontal="true" >
              <b-form-input id="newsSubtitle" 
                      type="text" required
                      autocomplete="name" 
                      v-model="newsData.subtitle" 
                      placeholder="Enter news subtitle...">
              </b-form-input>
            </b-form-group>
         
            <b-form-group
             label="Description"
              label-for="newsDescription"
              :label-cols="3"
              :horizontal="true"
            >
            <b-form-textarea id="newsDescription"
                        v-model="newsData.description"
                        placeholder="Enter news description..."
                        :rows="3"
                        :max-rows="6"
                        size="sm">
              </b-form-textarea>
            </b-form-group>
            <b-form-group
             validated
            label="Source url"
            label-for="newsSource"
            :label-cols="3"
            :horizontal="true"
            >
            <b-form-input id="newsSource" 
                      type="url" required
                      autocomplete="name" 
                      v-model="newsData.sourceUrl" 
                      placeholder="Enter source url...">
              </b-form-input>
            </b-form-group>
            <b-form-group 
              validated
              label="Upload news front image"
              label-for="mediaFileInput"
              :label-cols="3"
              :horizontal="true">
                <b-form-file accept="image/*" id="mediaFileInput" :plain="true" required v-model="newsData.mediaFile"></b-form-file>
            </b-form-group>
             <b-form-group>
               <!-- Begin Vue editor -->
               <!-- <vue-editor v-model="newsData.contentHtml"></vue-editor> -->
              <quill-editor v-model="newsData.contentHtml"
                             :options= "editorOption"
                            ref="myQuillEditor"
                            @blur="onEditorBlur($event)"
                            @focus="onEditorFocus($event)"
                            @ready="onEditorReady($event)">
              </quill-editor>
            </b-form-group>
          <!-- <b-form-group v-if="newsData.mediaFile != null" > New image
            <b-img v-bind:src="getMediaFileImage()" fluid alt="Responsive image" />
          </b-form-group>
          <b-form-group v-if="previewImageUrl != null" > Old image
            <b-img v-bind:src="previewImageUrl" fluid alt="Responsive image" />
          </b-form-group> -->
          <div slot="footer">
            <b-row class="align-items-center">
              <b-col xl= "2" class="mb-3 mb-xl-0" >
                <b-button v-on:click="goBack" block variant="secondary">Back</b-button>
              </b-col>
              <b-col xl= "6" class="mb-3 mb-xl-0" >
                <b-button type="submit"  v-if="!isEdit" v-on:click="confirmNewsButton" block variant="primary"><i class="fa fa-dot-circle-o"></i> Confirm News</b-button>
                <b-button type="submit" v-if="isEdit" v-on:click="updateNews" block variant="primary"><i class="fa fa-dot-circle-o"></i> Save Changes</b-button>
              </b-col>
              <b-col xl= "4" class="mb-3 mb-xl-0" >
                <b-button type="submit" v-if="isEdit" v-on:click="removeNews" block variant="danger"><i class="fa fa-ban"></i> Remove News</b-button>
              </b-col>
            </b-row>
          </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="4">
        <b-card v-if="previewImageUrl != null">
          <div slot="header">
            <strong>Front image</strong>
          </div>
          <b-form-group>
            <b-img v-bind:src="previewImageUrl" fluid alt="Responsive image" />
          </b-form-group>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card v-if="newsData.mediaFile != null">
          <div slot="header">
            <strong>New front image</strong>
          </div>
          <b-form-group>
            <b-img v-bind:src="getMediaFileImage()" fluid alt="Responsive image" />
          </b-form-group>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import _ from 'underscore'
import { db } from '@/config/devowqlo';
import { storage } from '@/config/devowqlo';
import { auth } from '@/config/devowqlo';
import { functions } from '@/config/devowqlo';

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor, Quill } from 'vue-quill-editor'
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)

export default {
  components: {
      quillEditor
   },
  name: 'forms',
  firebase: {
    newsDraft: db.ref('news/draft'),
    newsPublished: db.ref('news/published'),
    counts: db.ref('counts')
  },
  data () {
    return {
      isEdit: false,
      isPublished: false,
      newsData: {
        key: null,
        title: null,
        subtitle: null,
        description: null,
        sourceUrl: null,
        mediaUrl: null,
        thumbMediaUrl: null,
        contentHtml: '',
        mediaFile: null
      },
      editorOption: {
        modules: {
          imageDrop: true,
          imageResize: true,
          toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'script': 'sub' }, { 'script': 'super' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'direction': 'rtl' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'font': [] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }],
              ['clean'],
              [/*'link', 'image', 'video'*/]
            ]
        },
        theme: 'snow'
      },
      previewImage: null,
      previewImageUrl: null
    }
  },
  created() {
    if(this.$route.params.id){
      this.newsData.key = this.$route.params.id
      this.isPublished = (this.$route.params.isPublished === "true")

      this.setNews()
    }
  },
 methods: {
      onEditorBlur(editor) {
        console.log('editor blur!', editor)
      },
      onEditorFocus(editor) {
        console.log('editor focus!', editor)
      },
      onEditorReady(editor) {
        console.log('editor ready!', editor)
      },
      removeNews() {
      //Remove storage files
      var mediaRef = storage.ref().child("NewsFiles").child(this.newsData.mediaUrl)
      var thumbMediaRef = storage.ref().child("NewsFiles").child(this.newsData.thumbMediaUrl)

      // Delete the file
      mediaRef.delete().then(function() {
        // File deleted successfully
      }).catch(function(error) {
        // Uh-oh, an error occurred!
      });

      // Delete the file
      thumbMediaRef.delete().then(function() {
        // File deleted successfully
      }).catch(function(error) {
        // Uh-oh, an error occurred!
      });

      if (this.isPublished) {
        this.$firebaseRefs.newsPublished.child(this.newsData.key).remove()
      } else {
        this.$firebaseRefs.newsDraft.child(this.newsData.key).remove()
      }

      var countRef = this.$firebaseRefs.counts.child('newsCount').child('count')

      countRef.transaction(function(count) {
        if (count) {
          if(count > 0){
            count = count - 1;
          }
        }else{
          count = 0
        }
        return count;
      })

      this.$router.go(-1)
    },
    updateNews(){
      if(this.newsData.mediaFile != null){
        if(this.newsData.mediaUrl != null){
          //Remove storage files
          var mediaRef = storage.ref().child("NewsFiles").child(this.newsData.mediaUrl)
          var thumbMediaRef = storage.ref().child("NewsFiles").child(this.newsData.thumbMediaUrl)

          // Delete the file
          mediaRef.delete().then(function() {
            // File deleted successfully
          }).catch(function(error) {
            // Uh-oh, an error occurred!
          });

          // Delete the file
          thumbMediaRef.delete().then(function() {
            // File deleted successfully
          }).catch(function(error) {
            // Uh-oh, an error occurred!
          });
        } 

        console.log("Uploading media file...")
        const mediaName = (+new Date()) + '-' + this.newsData.mediaFile.name;
        const mediaMetadata = { contentType: this.newsData.mediaFile.type };
        const uploadTask = storage.ref().child("NewsFiles").child(mediaName).put(this.newsData.mediaFile, mediaMetadata)
        .then(snapshot => snapshot.ref.getDownloadURL())
        .then(url => {
          this.previewImageUrl = url

          const thumbMediaName = 'thumb_' + mediaName
          const dateNow = Date.now()

          var newsModel = { 
            title: this.newsData.title,
            subtitle: this.newsData.subtitle,
            description: this.newsData.description,
            contentHtml: this.newsData.contentHtml,
            sourceUrl: this.newsData.sourceUrl,
            mediaUrl: mediaName,
            thumbMediaUrl: thumbMediaName,
            modified: dateNow
          }

          if (this.isPublished) {
            db.ref('news/published').child(this.newsData.key).update(newsModel)
          } else {
            db.ref('news/draft').child(this.newsData.key).update(newsModel)
          }
          
        })
      }else{

        const dateNow = Date.now()

        var newsModel = { 
          title: this.newsData.title,
          subtitle: this.newsData.subtitle,
          description: this.newsData.description,
          contentHtml: this.newsData.contentHtml,
          sourceUrl: this.newsData.sourceUrl,
          modified: dateNow
        }

        if (this.isPublished) {
          db.ref('news/published').child(this.newsData.key).update(newsModel)
        } else {
          db.ref('news/draft').child(this.newsData.key).update(newsModel)
        }
      }

      console.log(auth.currentUser.uid)
      db.ref('users/admins').child(auth.currentUser.uid).once('value', (snapshot) => {
        console.log(snapshot.val().name)

        var createdByModel = {
          name: snapshot.val().name,
          lastName: snapshot.val().lastName
        }
        if (this.isPublished) {
          db.ref('news/published').child(this.newsData.key).child('modifiedBy').child(auth.currentUser.uid).set(createdByModel)
        } else {
          db.ref('news/draft').child(this.newsData.key).child('modifiedBy').child(auth.currentUser.uid).set(createdByModel)
        }
      })

      this.$router.go(-1)
    },
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    setNews(){
      this.isEdit = true
      var ref = null
      if (this.isPublished) {
        ref =  this.$firebaseRefs.newsPublished.ref
      } else {
         ref =  this.$firebaseRefs.newsDraft.ref
      }
      ref.child(this.newsData.key).
          once('value', (snap) => {
            this.newsData.title = snap.val().title
            this.newsData.subtitle = snap.val().subtitle
            this.newsData.description = snap.val().description
            this.newsData.contentHtml = snap.val().contentHtml
            this.newsData.sourceUrl = snap.val().sourceUrl
            this.newsData.mediaUrl = snap.val().mediaUrl
            this.newsData.thumbMediaUrl = snap.val().thumbMediaUrl
          });

      storage.ref().child("NewsFiles").child(this.newsData.thumbMediaUrl).getDownloadURL().then((url) => {

        this.previewImageUrl = url
      }).catch(function(error) {
        // Handle any errors
      });
      
    },
    getMediaFileImage(){
        console.log(this.newsData.mediaFile)
        var reader = new FileReader()
        reader.onload = (e) => {
          this.previewImage = e.target.result
        }
        reader.readAsDataURL(this.newsData.mediaFile)

        return this.previewImage
    },
    confirmNewsButton () {
      console.log(validated);
      
      this.addNews()
    },
    addNews(){
      this.uploadPictureFile();
    },

        // NEW!!
    notifyAllUsers(type, typeId, typeName, action) {  
      const dateNow = Date.now()

      var notificationModel = {
        type: type ,
        typeId: typeId,
        typeName: typeName,
        action: action,
        timestamp: dateNow,
         viewed: false 
      }

      console.log("<-- NOTIFY ALL USERS");
      console.log(notificationModel);
      
        db.ref('users').child('parents').once('value', (snapParents) => {
          db.ref('users').child('coaches').once('value', (snapCoaches) => {
            db.ref('users').child('players').once('value', (snapPlayers) => {
            
            console.log("Notifing coaches..."); 
            snapCoaches.forEach((childSnapshot) => {
              var coachKey = childSnapshot.key;   
              db.ref('userNotifications').child(coachKey).child('notifications').push(notificationModel)
            })  

            console.log("Notifing coaches... ");
            snapPlayers.forEach((childSnapshot) => {
              var playerKey = childSnapshot.key;
              db.ref('userNotifications').child(playerKey).child('notifications').push(notificationModel)
            })

            console.log("Notifing parents...");
            snapParents.forEach((childSnapshot) => {
              var parentKey = childSnapshot.key;
              db.ref('userNotifications').child(parentKey).child('notifications').push(notificationModel)
            })
          })
        })
      })   
    },

    uploadPictureFile(){
      console.log("Uploading media file...")
      const mediaName = (+new Date()) + '-' + this.newsData.mediaFile.name;
      const mediaMetadata = { contentType: this.newsData.mediaFile.type };
      const uploadTask = storage.ref().child("NewsFiles").child(mediaName).put(this.newsData.mediaFile, mediaMetadata)
        .then(snapshot => snapshot.ref.getDownloadURL())
        .then(url => {
          this.previewImageUrl = url
          this.createNewsDb(mediaName)
        })
    },

    createNewsDb(mediaName){
      
      console.log("Creating news on DB...")
       
      const thumbMediaUrl = 'thumb_' + mediaName
      const dateNow = Date.now()

      var newsModel = { 
        title: this.newsData.title,
        subtitle: this.newsData.subtitle,
        description: this.newsData.description,
        contentHtml: this.newsData.contentHtml,
        sourceUrl: this.newsData.sourceUrl,
        mediaUrl: mediaName,
        thumbMediaUrl: thumbMediaUrl,
        created: dateNow,
        modified: dateNow
      }

      var newsKey = this.$firebaseRefs.newsDraft.push(newsModel).key

      console.log(auth.currentUser.uid)
      db.ref('users/admins').child(auth.currentUser.uid).once('value', (snapshot) => {
        console.log(snapshot.val().name)

        var createdByModel = {
          name: snapshot.val().name,
          lastName: snapshot.val().lastName
        }

        //Created by
        db.ref('news/draft').child(newsKey).child('createdBy').child(auth.currentUser.uid).set(createdByModel)
        db.ref('news/draft').child(newsKey).child('modifiedBy').child(auth.currentUser.uid).set(createdByModel)
      })

      var countRef = this.$firebaseRefs.counts.child('newsCount').child('count')
      countRef.transaction(function(count) {
        if (count) {
          count = count + 1;
        }else{
          count = 1
        }
        return count;
      })

      this.$router.go(-1)
    
    }
  },
}
</script>

<style scoped lang="scss" > 
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

</style>

// getAge(birthdate) {
    //   var today = new Date();
    //   var birthDate = new Date(birthdate);
    //   var age = today.getFullYear() - birthDate.getFullYear();
    //   var m = today.getMonth() - birthDate.getMonth();
    //   if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    //       age--;
    //   }    
    //   return age;
    // }
    // console.log(this.newUser.birthdate)
      // const timestamp = new Date(this.newUser.birthdate).getTime()
      // console.log(timestamp)
      // const dateFromTimestamp = new Date(timestamp)
      // console.log(dateFromTimestamp)

      // if(this.$route.params.teamid != null){
      //   console.log(this.$route.params.teamid)
      // }else{
      //   console.log("No hay id equipo")
      // }

      // Get a key for a new User.
      // var newUserKey = this.$firebaseRefs.users.push().key;

      // this.$firebaseRefs.users.child(newUserKey).set({
      //    name: this.userName,
      //    category: this.categorySelect
      // })

      // this.$firebaseRefs.users.child().set({
      //   name: this.userName,
      //   category: this.categorySelect
      // })